import React from 'react';
import Image from 'next/image';
import { Container, Typography, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useIntl } from '@klokhuis/core/Intl';
import styles from './AgentPartnership.module.css';
import { ROUTES } from '@klokhuis/core/Routing';
import { NavLink } from '@klokhuis/core/Routing/NavLink';
import { useMediaIsDesktop } from '@klokhuis/utilities/Media/useMediaIsDesktop';

const AgentPartnership = () => {
  const { T } = useIntl();
  const isDesktop = useMediaIsDesktop();

  return (
    <section className={styles.root}>
      {/* Decorative background shapes */}
      <div className={styles.dotsContainer}>
        <Image
          src="/images/dots.svg"
          alt="dots"
          width={100}
          height={100}
          className={styles.dotsImage}
        />
      </div>

      <div className={styles.circlesContainer}>
        <Image
          src="/images/circles.svg"
          alt="circles"
          width={400}
          height={400}
          className={styles.circlesImage}
        />
      </div>

      <Container maxWidth="xl" className={styles.container}>
        <div className={styles.content}>
          <Typography variant={isDesktop ? 'h3' : 'h5'}>
            {T('agent_partnership.title')}
          </Typography>
          <Typography variant={isDesktop ? 'subtitle1' : 'caption'}>
            {T('agent_partnership.subtitle')}
          </Typography>
          <NavLink.Wrap href={ROUTES.CreateProperty.url({})}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              endIcon={<ArrowForwardIcon />}
            >
              {T('agent_partnership.button')}
            </Button>
          </NavLink.Wrap>
        </div>
      </Container>
    </section>
  );
};

export default AgentPartnership;
